module.exports = __webpack_public_path__ + "static/media/50-off-campaign-everyday-digital.00570c21.png";